import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react"
import { defPath } from '../config/defPath'
import { submitLogin, submitRetrieve, initTime } from "../components/layout/sendForm"
import ValidateToken from "../components/layout/validateToken"
import { Link, Route, Switch, useLocation } from "wouter"

// @ts-ignore
import * as Bouncer from 'formbouncerjs'

const urls = {
  login: '/estadio-aguila/iniciar-sesion',
  forgot: '/estadio-aguila/recuperar-contrasena',
  send: '/estadio-aguila/correo-enviado',
  new: '/estadio-aguila/nueva-contrasena',
}

export default function NewLogin() {
  const [currentForm, setCurrentForm] = useState(null)

  const handleClose = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Close Login',
      'interaction': 'true',
      'component_name': 'Login',
      'element_text': 'Cerrar Login',
    });

    window.location.href = "/copa-america/predicciones"
    // const close = document.querySelector('#closeModal')
    // close?.addEventListener('click', e =>{            
    // })
  }

  const validateUser = async () => {
    if (window.drupalSettings && window.drupalSettings.user.uid > 0 && sessionStorage.getItem("user-estadio")) {
        let userData = JSON.parse(sessionStorage.getItem("user-estadio"))
        if (userData.state.logged == true) location.href= '/aguila-millonaria';
    } 
  }

  useEffect(() => {
    validateUser()
  }, [])

  return (
    <>
      <div className="ar__content newLogin">
        <a href="/estadio-aguila" className="logo logo-modal">
          <img src={`${defPath}/assets/images/login/escudo.png`} alt="Logo Aguila" />
        </a>
        <a onClick={handleClose} className="close__modal" id="closeModal"></a>
        <Switch>
          <Route path={urls.login}>
            <Login />
          </Route>
          <Route path={urls.forgot}>
            <ForgotPassword setCurrentForm={setCurrentForm} />
          </Route>
          <Route path={urls.send}>
            <SendPassword form={currentForm} />
          </Route>
          <Route path={urls.new}>
            <ValidateToken />
          </Route>
        </Switch>

      </div>
    </>
  )
}

function Login() {
  const [fieldSets, setFieldSet] = React.useState({ name: '', lastname: '', document: '' })
  const [showPass, setshowPass] = useState(false)

  const handleShowPass = () => {
    setshowPass(prevState => !prevState)
  }

  const handleChange = (e: any) => {
    const isValid = e.target.validity.valid;
    let parent = e.target.closest('.row'),
      label = parent.querySelector('label')
    if (e.target.value.length >= 1) {
      label.classList.add('activeLabel')
    } else {
      label.classList.remove('activeLabel')
    }
    if (!isValid && e.target.value) return
    const { name, value } = e.target
    setFieldSet({ ...fieldSets, [name]: value })
  }

  const sendDatalayerLogin = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Login',
      'event_action': 'Submit',
      'event_label': 'Login Submit',
    });
  }
  const sendDatalayerForgotPass = (event: any) => {
    const label = event.target.textContent;
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Forgot Password',
      'interaction': 'true',
      'component_name': 'Login',
      'element_text': label,
    });
  }

  const handleBouncerFormValidate = (event: any) => {
    let id = event.target.getAttribute('id')

    if (id == 'login') {
      submitLogin(event.target)
    }
  }

  React.useEffect(() => {
    const bouncer = new Bouncer('#login', {
      messages: {
        missingValue: {
          default: 'Este campo es obligatorio',
          select: 'Este campo es obligatorio',
          checkbox: 'Este campo es obligatorio',
        },
        patternMismatch: {
          email: 'Ingresa un correo válido',
        },
      },
      disableSubmit: true
    })

    if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
      const noaccount = document.querySelector("#no-account") as HTMLAnchorElement
      var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
      noaccount.querySelector("a").href = '/estadio-aguila/registro?redirect=' + parameterValue
    }

    document.addEventListener('bouncerFormValid', handleBouncerFormValidate);
    return () => {
      document.removeEventListener('bouncerFormValid', handleBouncerFormValidate);
    };
  }, [])




  return (
    <>
      <div className={`ar__login  ar__content__section animate-fade`} id="sectionLogin">
        <div className="ar__content__title">
          <h1 className="ar__login__title title_2 whiteShadow"><span>Iniciar</span> sesión</h1>
        </div>

        <form method="post" id="login" className="ar__login__form">
          <div className="row">
            <Input type="email" name="email" autoComplete="off" required onChange={handleChange} />
            <label htmlFor="email" className="black_30 whiteShadow">Correo electrónico</label>
          </div>
          <div className="row">
            <div className="passwordBox">
              <Input type={`${showPass ? 'text' : 'password'}`} name="password" autoComplete="off" required />
              <label htmlFor="password" className="black_30 whiteShadow">Contraseña</label>
              <div className="eye" onClick={handleShowPass}></div>
            </div>
          </div>
          <Link href={urls.forgot} onClick={sendDatalayerForgotPass} className="ar__login__forget black_24 yellow">¿Olvidaste tu contraseña?</Link>

          <button type="submit" className="ar__btn ar__btn-primary" onClick={sendDatalayerLogin}>iniciar sesión</button>
        </form>
      </div>
      <NoAccount />
    </>
  )
}

export function NoAccount() {
  return (
    <div className="ar__NoAccount" id="no-account">
      <span className="ar__NoAccount--text">¿no tienes cuenta aún?</span>
      <a className="ar__NoAccount--btn" href="/estadio-aguila/registro">Regístrate aquí</a>
    </div>
  )
}

type InputProps = InputHTMLAttributes<HTMLInputElement>

export function Input(props: InputProps) {
  const input = useRef<HTMLInputElement>(null)
  const [disabled, setDisabled] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setDisabled(false)
    }, 1000);
  }, [])

  return (
    <input ref={input} {...props} disabled={disabled} />
  )
}

function ForgotPassword({ setCurrentForm }: any) {
  const [location, navigate] = useLocation();
  const [fieldSets, setFieldSet] = React.useState({ name: '', lastname: '', document: '' })

  const handleChange = (e: any) => {
    const isValid = e.target.validity.valid;
    let parent = e.target.closest('.row'),
      label = parent.querySelector('label')
    if (e.target.value.length >= 1) {
      label.classList.add('activeLabel')
    } else {
      label.classList.remove('activeLabel')
    }
    if (!isValid && e.target.value) return
    const { name, value } = e.target
    setFieldSet({ ...fieldSets, [name]: value })
  }

  const sendDatalayerRecovery = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Password Recovery',
      'interaction': 'true',
      'component_name': 'Password Recovery',
      'element_text': 'Recuperar',
    });
  }

  const handleFormRetrieve = (event: any) => {
    let id = event.target.getAttribute('id')

    if (id == 'retrieve') {
      submitRetrieve(event.target).then(res => {
        if (res?.statusCode == 200) {
          setCurrentForm(event.target)
          navigate(urls.send)
        } else if (res?.statusCode == 401) {
          navigate(urls.send)
        } else {
          if (res) {
            const error = document.getElementById('error-drupal')
            if (!error) return
            error.classList?.add('error-drupal')
            error.innerHTML = res?.data.message

            setTimeout(() => {
              error.classList?.remove('error-drupal')
              error.innerHTML = ""
            }, 5000);
          }

        }
      })
    }

    window.isSend = false
  }

  React.useEffect(() => {
    const bouncer = new Bouncer('#retrieve', {
      messages: {
        missingValue: {
          default: 'Este campo es obligatorio',
          select: 'Este campo es obligatorio',
          checkbox: 'Este campo es obligatorio',
        },
        patternMismatch: {
          email: 'Ingresa un correo válido',
        },
      },
      disableSubmit: true
    })
    document.removeEventListener('bouncerFormValid', handleFormRetrieve);
    document.addEventListener('bouncerFormValid', handleFormRetrieve);
    return () => {
      document.removeEventListener('bouncerFormValid', handleFormRetrieve);
    };
  }, [])

  return (
    <>
      {/* RECORDAR CONTRASEñA */}
      <div className="ar__forget ar__content__section animate-fade" id="sectionForget">
        <a href="/estadio-aguila" className="logo logo-modal">
          <img src={`${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Aguila" />
        </a>
        <div className="ar__content__title">
          <h2 className="ar__login__title title_2 whiteShadow"><span>recuperar</span> contraseña</h2>
        </div>


        <form id="retrieve" className="ar__login__form">
          <div className="row">
            <input required type="email" name="email" placeholder="Ingresa tu correo electrónico" onChange={handleChange} />
            <label htmlFor="email" className="black_30 whiteShadow">Correo electrónico</label>
          </div>

          <p className="ar__forget__text medium_30">Te enviaremos un email con un link para que reestablezcas tu contraseña.</p>

          <button type="submit" className="ar__btn ar__btn-primary" onClick={sendDatalayerRecovery}>Recuperar</button>
          <Link href={urls.login} type="button" className="ar__forget__textBtn yellow">Volver</Link>
          <div id="error-drupal" className="blur-in"></div>
        </form>
      </div>
    </>
  )
}

function SendPassword({ form }: any) {

  const sendDatalayerLoginRecovery = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Login Password Recovery',
      'interaction': 'true',
      'component_name': 'Password Recovery',
      'element_text': 'Iniciar Sesión',
    });
  }

  const handleRetrieve = () => {
    submitRetrieve(form)
    initTime()
  }

  useEffect(() => {
    initTime()
  }, [])


  return (
    <>
      {/* RESTABLECER CONTRASEñA */}
      <div className="ar__send ar__content__section animate-fade" id="sectionSend">
        <div className="ar__content__title">
          <h2 className="ar__login__title title_2 whiteShadow"><span>Correo</span> enviado</h2>
        </div>

        <p className="ar__send__text medium_30 whiteShadow">Te hemos enviamos un link para que reestablezcas tu contraseña.</p>

        <div className="time white whiteShadow" id="time">00:00</div>

        <p className="ar__send__text2 medium_24 whiteShadow disabled">¿No te llegÓ el correo? <br />
          <a id="reenviar" className="yellow yellowShadow" onClick={handleRetrieve}>Reenviar</a>
        </p>

        <Link className="ar__btn ar__btn-primary hidden" href={urls.login} id="backSesion" onClick={sendDatalayerLoginRecovery}>Iniciar sesión</Link>
      </div>
    </>
  )
}
